import React, { useState, useEffect } from "react";
import VoiceRecorder from "./VoiceRecorder";
import MasterOrch from "./MasterIvr";
import aiAgentLogo from "../assests/image.png";
import WeatherScreenRecorder from "./WeatherPage";
import SchemePage from "./SchemePage";
import Authentication from "./Authentication";
import AdminPage from "./AdminPage";

import odishaLogo from "../assests/odishaLogo.svg";
import sealOfOdissa from "../assests/sealOfOdissa.svg";
import cmOfOdisha from "../assests/cm_of_odisha.png";
import farmerLogo from "../assests/farmerLogo.svg";

import "./LandingPage.css";

const LandingPage = () => {
    const [page, setPage] = useState("landing");

    const goToPage = (pageKey, urlPath) => {
        if (typeof window !== "undefined" && window.history && urlPath) {
            window.history.pushState({}, "", urlPath);
        }
        setPage(pageKey);
    };

    const onBack = () => {
        if (typeof window !== "undefined" && window.history) {
            window.history.replaceState({}, "", "/");
        }
        setPage("landing");
    };

    useEffect(() => {
        if (typeof window === "undefined") return;

        const syncPageWithUrl = () => {
            const path = window.location.pathname;
            switch (path) {
                case "/":
                    setPage("landing");
                    break;
                case "/weather_agent":
                    setPage("weather");
                    break;
                case "/artificial_insemination_agent":
                    setPage("farmer");
                    break;
                case "/pest_agent":
                    setPage("masterorch");
                    break;
                case "/schemes_agent":
                    setPage("scheme");
                    break;
                case "/admin_portal":
                    setPage("auth");
                    break;
                case "/admin_uploads":
                    setPage("admin");
                    break;
                default:
                    setPage("landing");
                    break;
            }
        };

        syncPageWithUrl();
        window.addEventListener("popstate", syncPageWithUrl);
        return () => window.removeEventListener("popstate", syncPageWithUrl);
    }, []);

    useEffect(() => {
        if (typeof window !== "undefined" && page === "landing" && window.location.pathname !== "/") {
            window.history.replaceState({}, "", "/");
        }
    }, [page]);

    const onAdmin = () => goToPage("auth", "/admin_portal");
    const onAdminSuccess = () => goToPage("admin", "/admin_uploads");

    if (page === "auth") {
        return (
            <div className="relative min-h-screen" style={{ width: '100%' }}>
                <Authentication onBack={onBack} onSuccess={onAdminSuccess} />
            </div>
        );
    }

    if (page === "farmer") {
        return (
            <div className="relative min-h-screen" style={{ width: '100%' }}>
                <VoiceRecorder onBack={onBack} />
            </div>
        );
    }

    if (page === "masterorch") {
        return (
            <div className="relative min-h-screen" style={{ width: '100%' }}>
                <MasterOrch onBack={onBack} />
            </div>
        );
    }

    if (page === "scheme") {
        return (
            <div className="relative min-h-screen" style={{ width: '100%' }}>
                <SchemePage onBack={onBack} onAdmin={onAdmin} />
            </div>
        );
    }

    if (page === "admin") {
        return (
            <div className="relative min-h-screen" style={{ width: '100%' }}>
                <AdminPage onBack={onBack} />
            </div>
        );
    }

    if (page === "weather") {
        return (
            <div className="relative min-h-screen" style={{ width: '100%' }}>
                <WeatherScreenRecorder onBack={onBack} />
            </div>
        );
    }

    return (
        <div className="landing-wrapper">
            <header className="gov-header">
                <div className="header-left-logos">
                    <img src={odishaLogo} alt="Odisha Logo" className="gov-logo" />
                    <div className="logo-divider"></div>
                    <img src={sealOfOdissa} alt="Seal of Odisha" className="gov-logo" />
                </div>
                <div className="header-center-text">
                    <span className="gov-title">KRUSHI SAMRUDHI HELPLINE</span>
                    <span className="gov-subtitle">Government of Odisha</span>
                </div>
                <div className="header-right-logos">
                    <div className="cm-text-box">
                        <div className="cm-name">Shri Mohan Charan Majhi</div>
                        <div className="cm-title">Hon'ble Chief Minister of Odisha</div>
                    </div>
                    <img src={cmOfOdisha} alt="CM of Odisha" className="gov-logo" />
                    <div className="logo-divider"></div>
                    <img src={farmerLogo} alt="Farmer Logo" className="gov-logo rounded" />
                </div>
            </header>
            <main className="main-canvas">
                <div className="bg-decoration hero-pattern"></div>
                <div className="bg-glow"></div>

                <div className="content-container">
                    {/* Hero Content */}
                    <div className="hero-section">
                        {/* <div className="pill-badge">
                            <span className="material-symbols-outlined">psychology</span>
                            Smart Agriculture Assistance
                        </div> */}
                        <div className="title-wrapper" style={{ marginTop: '20px', marginBottom: '15px' }}>
                            <h1 className="main-title" style={{ fontSize: '42px', fontWeight: 'bold', color: '#1f2937' }}>
                                Smart Agriculture <span style={{ color: '#00a35c' }}>Assistance</span>
                            </h1>
                        </div>
                        <p className="subtitle">
                            Nurturing growth through technology. Get instant access to expert agricultural advice and AI-driven insights for your farm.
                        </p>
                    </div>

                    {/* Feature Grid */}
                    <div className="feature-grid">
                       {/* Weather Agent */}
                        <div
                            onClick={() => goToPage("weather", "/weather_agent")}
                            className="feature-card card-weather"
                        >
                            <div className="icon-box">
                                <span className="material-symbols-outlined">partly_cloudy_day</span>
                            </div>
                            <h3 className="card-title">Weather Agent</h3>
                            <p className="card-desc">Hyper-local forecasts and climate alerts tailored to your crops' needs.</p>
                        </div>

                        {/* Artificial Insemination Agent */}
                        <div
                            onClick={() => goToPage("farmer", "/artificial_insemination_agent")}
                            className="feature-card card-ai"
                        >
                            <div className="icon-box">
                                <img src={aiAgentLogo} alt="Artificial Insemination Agent" className="custom-agent-icon" />
                            </div>
                            <h3 className="card-title">Artificial Insemination Agent</h3>
                            <p className="card-desc">Expert guidance and scheduling for livestock breeding and genetic improvement.</p>
                        </div>

                        {/* Pest Agent */}
                        <div
                            onClick={() => goToPage("masterorch", "/pest_agent")}
                            className="feature-card card-pest"
                        >
                            <div className="icon-box">
                                <span className="material-symbols-outlined">bug_report</span>
                            </div>
                            <h3 className="card-title">Pest Agent</h3>
                            <p className="card-desc">Instant pest identification and eco-friendly management solutions.</p>
                        </div>

                        {/* Schemes Agent */}
                        <div
                            onClick={() => goToPage("scheme", "/schemes_agent")}
                            className="feature-card card-schemes"
                        >
                            <div className="icon-box">
                                <span className="material-symbols-outlined">account_balance</span>
                            </div>
                            <h3 className="card-title">Schemes Agent</h3>
                            <p className="card-desc">Navigate government subsidies and agricultural welfare programs easily.</p>
                        </div>
                    </div>
                </div>

                {/* Featured Image */}
                <div className="hero-image-container">
                    <img
                        alt="A lush, green agricultural landscape"
                        className="hero-image"
                        src="https://lh3.googleusercontent.com/aida-public/AB6AXuDFmYYLgE2lm3eQ3gSUze7M8DY52gfGETIGYiS5Wa3SC8ksTYQ6rqVz2u1LmfUltoWyDRkeGtmXYZOWjVIzB3_Q0hAqQPnzLjFg8a8l44GCRd-4KavSP1N9_Lr1PPWd5t9YObzs-OaOsIlvDaxKGtIo6cC95PqitVOhOkpIq8HWC7ZYFnDzZFz-8wN6yLQaKmDKVvnTnt1Bv-zyeQQwanqICgSWy7Wk1yxxBDPNnhtEfJDFlJ0DWM0NCowlAxzwxtChtuZZTYfXOtmj"
                    />
                </div>
            </main>

            {/* Footer */}
            <footer className="footer">
                <div className="footer-container">
                    <div className="footer-brand">
                        Krushi Samrudhi Helpline
                    </div>
                    <p className="copyright">
                        © 2026.
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;